import { render, staticRenderFns } from "./phone_swiper.vue?vue&type=template&id=8e65a9c2&scoped=true"
import script from "./phone_swiper.vue?vue&type=script&lang=js"
export * from "./phone_swiper.vue?vue&type=script&lang=js"
import style0 from "./phone_swiper.vue?vue&type=style&index=0&id=8e65a9c2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e65a9c2",
  null
  
)

export default component.exports